module.exports = __webpack_public_path__ + "static/media/2.73ce3c67.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/gifshop/gifs/2.gif
// module id = 243
// module chunks = 0